import { ActionId, ActionModel, ContractCategory } from "src/app/v2/pages/contracts/models/contracts.models";

export const generateMockActions = (): { payload: ActionModel[] } => {
  return {
    payload: [
      {
        id: ActionId.MovePension,
        name: "Flytt avtale til Storebrand",
        detailsLink: null,
        contracts: [
          {
            id: "EPK_PKB",
            name: "Egen pensjonskonto eller Pensjonskapitalbevis",
            type: null,
            navigationLink: "https://www.storebrand.no/pensjon/flytt/",
            totalBalance: null,
            totalReturn: null,
            nextDepositDate: null,
            monthlyDepositAmount: null,
          },
          {
            id: "IPS",
            name: "Individuell Pensjonssparing",
            type: null,
            navigationLink: "https://www.storebrand.no/pensjon/ips/flytt-eller-ny-ips",
            totalBalance: null,
            totalReturn: null,
            nextDepositDate: null,
            monthlyDepositAmount: null,
          },
          {
            id: "FMI",
            name: "Fripolise",
            type: null,
            navigationLink: "https://www.storebrand.no/pensjon/flytt-fripolise/",
            totalBalance: null,
            totalReturn: null,
            nextDepositDate: null,
            monthlyDepositAmount: null,
          },
        ],
      },
      {
        id: ActionId.ChangeInvestment,
        name: "Endre investering",
        detailsLink: null,
        contracts: [
          {
            id: "123123.10",
            name: "Egen pensjonskonto",
            type: ContractCategory.Employer,
            navigationLink: "https://www.storebrand.no/endre-investering/123123.10",
            totalBalance: null,
            totalReturn: null,
            nextDepositDate: null,
            monthlyDepositAmount: null,
          },
          {
            id: "456789.20",
            name: "IPS",
            type: ContractCategory.UserSavings,
            navigationLink: "https://www.storebrand.no/endre-investering/456789.20",
            totalBalance: null,
            totalReturn: null,
            nextDepositDate: null,
            monthlyDepositAmount: null,
          },
        ],
      },
      {
        id: ActionId.ChangeSavingsAgreement,
        name: "Endre spareavtale",
        detailsLink: null,
        contracts: [
          {
            id: "456789.20",
            name: "IPS",
            type: ContractCategory.UserSavings,
            navigationLink: "https://www.storebrand.no/endre-spareavtale/456789.20",
            totalBalance: null,
            totalReturn: null,
            nextDepositDate: "20. mars 2026",
            monthlyDepositAmount: 1000,
          },
          {
            id: "789012.30",
            name: "Ekstrapensjon",
            type: ContractCategory.UserSavings,
            navigationLink: "https://www.storebrand.no/endre-spareavtale/789012.30",
            totalBalance: null,
            totalReturn: null,
            nextDepositDate: "20. mars 2026",
            monthlyDepositAmount: 600,
          },
        ],
      },
      {
        id: ActionId.DepositMoney,
        name: "Sett inn penger",
        detailsLink: null,
        contracts: [
          {
            id: "123123.10",
            name: "Egen pensjonskonto",
            type: ContractCategory.Employer,
            navigationLink: "https://www.storebrand.no/sett-inn/123123.10",
            totalBalance: 514432,
            totalReturn: 46789,
            nextDepositDate: null,
            monthlyDepositAmount: null,
          },
        ],
      },
      {
        id: ActionId.AddContract,
        name: "Tilpass visning av kontoer",
        detailsLink: null,
        contracts: null,
        contractGroups: [
          {
            groupType: "FUND_BASED_PENSIONABLE",
            contracts: [
              {
                id: "4068110-2:PL_A",
                name: "Fondskonto Link",
                type: ContractCategory.UserSavings,
                navigationLink: null,
                totalBalance: 2282337,
                totalReturn: 2754337,
                monthlyDepositAmount: null,
                nextDepositDate: null,
              },
              {
                id: "119110207980:SAM_A",
                name: "Aksjesparekonto",
                type: ContractCategory.UserSavings,
                navigationLink: null,
                totalBalance: 293315,
                totalReturn: null,
                monthlyDepositAmount: null,
                nextDepositDate: null,
              },
            ],
          },
          {
            groupType: "BANK_BASED_PENSIONABLE",
            contracts: [
              {
                id: "91007008835:SDC_A",
                name: "Smartkonto",
                type: ContractCategory.UserSavings,
                navigationLink: null,
                totalBalance: null,
                totalReturn: null,
                monthlyDepositAmount: null,
                nextDepositDate: null,
              },
            ],
          },
        ],
      },
      {
        id: ActionId.WithdrawMoney,
        name: "Ta ut penger",
        detailsLink: null,
        contracts: [
          {
            id: "456789.20",
            name: "IPS",
            type: ContractCategory.UserSavings,
            navigationLink: "https://www.storebrand.no/ta-ut/456789.20",
            totalBalance: 514432,
            totalReturn: 46789,
            nextDepositDate: null,
            monthlyDepositAmount: null,
          },
        ],
      },
    ],
  };
};
